import React, { useState } from 'react';
import appURLs from "../../appURL";
import getFetchConfig from "../../utils/getFetchConfig";

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0,
      width: '100%', height: '100%',
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000,
      
    }}>
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        padding: '4.1rem',
        width: '100%',
        maxWidth: '620px',
        minHeight: '280px',
        margin: '0 auto',
        fontFamily: 'system-ui, sans-serif',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: '1.5rem'
      }}>
        {children}
      </div>
    </div>
  );
};

const TransferModal = ({ adsId }) => {
  const fetchConfig = getFetchConfig();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [showEmailConfirmModal, setShowEmailConfirmModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const appURL = appURLs();

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleInitialSubmit = () => {
    if (!email.trim()) {
      setError('Email is required');
      return;
    }

    if (email && !validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    setError('');
    setTimeout(() => setShowEmailConfirmModal(true), 300);
  };

  const handleConfirmTransfer = async () => {
    setLoading(true);
    setError('');
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const type = localStorage.getItem("adsCategories");
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const res = await fetch(`${appURL}/customer/transfer/web`, {
        ...fetchConfig,
        method: 'POST',
        body: JSON.stringify({ email, adsId, userId: user.userId, type, timezone }),
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.message || 'Transfer failed');

      setShowEmailConfirmModal(false);
      setShowSuccessModal(true);
      setTimeout(() => window.location.reload(), 2000);
    } catch {
      setShowEmailConfirmModal(false);
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '1rem', display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
      <h3>Transfer Ad</h3>

      <input
        type="email"
        placeholder="Enter recipient's email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{ width: '100%', padding: '0.5rem', marginBottom: '1rem' }}
      />

      <button className="transfer_submit_btn" onClick={handleInitialSubmit} disabled={loading}>
        {loading ? 'Processing...' : 'Submit'}
      </button>

      {error && <p style={{ color: 'red', marginTop: '1rem' }}>{error}</p>}

      {/* Confirm Modal */}
      <Modal isOpen={showEmailConfirmModal} onClose={() => setShowEmailConfirmModal(false)}>
  <div style={{
    padding: '2rem',
    textAlign: 'center',
    fontFamily: 'system-ui, sans-serif',
  }}>
    <h2 style={{
      fontSize: '1.75rem',
      fontWeight: 700,
      color: '#212121',
      marginBottom: '1rem'
    }}>
      Confirm Ad Transfer
    </h2>

    <p style={{
      fontSize: '1.05rem',
      color: '#555',
      lineHeight: '1.6',
      marginBottom: '2rem'
    }}>
      Are you sure you want to transfer this ad to:
      <br />
      <strong style={{
        fontSize: '1.1rem',
        color: '#000',
        display: 'inline-block',
        marginTop: '0.5rem'
      }}>
        {email}
      </strong>
    </p>

    <div style={{
      display: 'flex',
      justifyContent: 'center',
      gap: '1rem',
      borderTop: '1px solid #eee',
      paddingTop: '1.5rem',
    }}>
      <button
        onClick={() => setShowEmailConfirmModal(false)}
        disabled={loading}
        style={{
          padding: '0.6rem 1.4rem',
          backgroundColor: '#fff',
          color: '#555',
          border: '1px solid #ccc',
          borderRadius: '8px',
          fontSize: '1rem',
          fontWeight: 500,
          cursor: loading ? 'not-allowed' : 'pointer',
          transition: 'all 0.3s ease',
          minWidth: '100px'
        }}
        onMouseOver={(e) => !loading && (e.currentTarget.style.backgroundColor = '#f5f5f5')}
        onMouseOut={(e) => !loading && (e.currentTarget.style.backgroundColor = '#fff')}
      >
        Cancel
      </button>

      <button
        onClick={handleConfirmTransfer}
        disabled={loading}
        style={{
          padding: '0.6rem 1.6rem',
          backgroundColor: '#1976d2',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          fontSize: '1rem',
          fontWeight: 600,
          cursor: loading ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.7 : 1,
          transition: 'background 0.3s ease',
          minWidth: '100px'
        }}
        onMouseOver={(e) => !loading && (e.currentTarget.style.backgroundColor = '#1565c0')}
        onMouseOut={(e) => !loading && (e.currentTarget.style.backgroundColor = '#1976d2')}
      >
        {loading ? 'Transferring...' : 'Confirm'}
      </button>
    </div>
  </div>
</Modal>

      {/* Success Modal */}
      <Modal isOpen={showSuccessModal} onClose={() => setShowSuccessModal(false)}>
  <div style={{
    padding: '2rem',
    textAlign: 'center',
    fontFamily: 'system-ui, sans-serif'
  }}>
    <div style={{
      fontSize: '2rem',
      marginBottom: '0.8rem'
    }}>
      ✅
    </div>

    <h2 style={{
      color: '#2e7d32',
      fontWeight: 700,
      fontSize: '1.75rem',
      marginBottom: '0.75rem'
    }}>
      Transfer Successful
    </h2>

    <p style={{
      color: '#444',
      fontSize: '1.05rem',
      lineHeight: '1.6',
      maxWidth: '420px',
      margin: '0 auto 1.8rem auto'
    }}>
      Your ad has been successfully transferred to:
      <br />
      <strong style={{
        color: '#2e7d32',
        fontWeight: 600,
        fontSize: '1.1rem'
      }}>
        {email}
      </strong>
    </p>
  </div>
</Modal>


      {/* Error Modal */}
<Modal isOpen={showErrorModal} onClose={() => setShowErrorModal(false)}>
  <div style={{
    padding: '2rem',
    textAlign: 'center',
    fontFamily: 'system-ui, sans-serif',
  }}>
    <div style={{
      fontSize: '2rem',
      marginBottom: '0.8rem'
    }}>
      ❌
    </div>

    <h2 style={{
      color: '#d32f2f',
      fontWeight: 700,
      fontSize: '1.75rem',
      marginBottom: '0.5rem'
    }}>
      Transfer Failed
    </h2>

    <p style={{
      color: '#555',
      fontSize: '1.05rem',
      lineHeight: '1.6',
      maxWidth: '420px',
      margin: '0 auto 1.8rem auto'
    }}>
      We couldn’t complete the transfer because the email address below was not found:
      <br />
      <strong style={{
        color: '#d32f2f',
        fontWeight: 600,
        display: 'inline-block',
        marginTop: '0.5rem'
      }}>
        {email}
      </strong>
    </p>

    <button
      onClick={() => setShowErrorModal(false)}
      style={{
        padding: '0.6rem 1.5rem',
        backgroundColor: '#d32f2f',
        color: '#fff',
        border: 'none',
        borderRadius: '8px',
        fontSize: '1rem',
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'background 0.3s ease'
      }}
      onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#b71c1c'}
      onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#d32f2f'}
    >
      Close
    </button>
  </div>
</Modal>

    </div>
  );
};

export default TransferModal;
